export const getAdditionalDataFunction = (imageFieldId) => {
  return (id, value) => {
    if (id === 'alt') return { alt_ai_generated: false };
    if (id !== imageFieldId) return {};

    const newImage = value?.[0];

    const defaults = {
      alt: '',
      alt_ai_generated: false,
      model_used: '',
      generation_date: '',
    };

    // if href was removed, set empty values to clear previous data
    if (!newImage) return defaults;

    // fallback values are needed for external images
    return {
      alt: newImage.alt_text || '',
      alt_ai_generated: Boolean(newImage.alt_text_ai_generated),
      model_used: newImage.alt_text_model_used || '',
      generation_date: newImage.alt_text_generation_date || '',
    };
  };
};
